import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer:DomSanitizer){}
  transform(value: string, ...args) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/safe-html/safe-html.ts